import { normalizePath } from '../../../../utils/path';

export async function execute(args, context) {
  const { dbRef } = context;
  const { path, start_line, end_line } = args;

  const normalizedPath = normalizePath(path);

  try {
    const content = await dbRef.current.get('files', normalizedPath);

    if (!content) {
      return {
        success: false,
        error: `File not found: ${normalizedPath}`
      };
    }

    const lines = content.split('\n');
    const totalLines = lines.length;

    // Full file read
    if (!start_line) {
      // Format with line numbers
      const numbered = lines.map((line, i) => `${i + 1}: ${line}`).join('\n');

      return {
        success: true,
        path: normalizedPath,
        totalLines,
        content: numbered
      };
    }

    // Line range read
    const start = Math.max(1, start_line);
    const end = Math.min(totalLines, end_line || start_line);

    if (start > totalLines) {
      return {
        success: false,
        error: `Start line ${start} exceeds file length (${totalLines} lines)`
      };
    }

    const selectedLines = lines.slice(start - 1, end);
    const numbered = selectedLines.map((line, i) => `${start + i}: ${line}`).join('\n');

    return {
      success: true,
      path: normalizedPath,
      totalLines,
      range: { start, end },
      content: numbered
    };
  } catch (err) {
    return {
      success: false,
      error: `Failed to read file: ${err.message}`
    };
  }
}
